<template>
  <div
    class="multiple-answer"
  >
    <div
      v-if="isOnboardingRedesign"
      class="tw-mb-6"
    >
      <div class="tw-flex tw-gap-2 tw-items-center">
        <img
          :src="require('@/assets/images/onboarding/doctor-image.png')"
          alt=""
          class="tw-h-[70px] tw-mr-2"
        >
        <h2
          class="tw-mb-0 tw-flex-1"
          :class="['question-title tw-font-atten', body.header ? 'with-subtext' : '']"
        >
          {{ body.question }}
        </h2>
      </div>
    </div>
    <template v-else>
      <h2 class="question-title">
        {{ body.question }}
      </h2>
    </template>
      
    <p
      v-if="body.header"
      :class="{'tw-text-black': isOnboardingRedesign}"
    >
      {{ body.header }}
    </p>

    <template v-if="!['K'].includes(onboardingVariant)">
      <w-checkbox
        v-if="body.allowempty"
        id="none"
        v-model="none"
        type="checkbox"
        value="true"
        label="None"
      />
    </template>

    <w-checkbox
      v-for="(list, i) in body.answerlist"
      :id="list.id"
      :key="list.name + i"
      v-model="answers"
      type="checkbox"
      :value="list.id"
      :label="list.name"
      :description="list.description"
    >
      <template
        v-if="list.image"
        #image
      >
        <div class="img-holder">
          <img
            :src="list.image"
            :alt="list.name"
          >
        </div>
      </template>
    </w-checkbox>

    <template v-if="['K'].includes(onboardingVariant)">
      <w-checkbox
        v-if="body.allowempty"
        id="none"
        v-model="none"
        type="checkbox"
        value="true"
        label="None"
      />
    </template>

    <template v-if="!isOnboardingRedesign">
      <w-checkbox
        v-if="body.hasothersarray"
        id="others"
        v-model="activateOthers"
        type="checkbox"
        value="true"
        label="Other"
      />
    </template>

    <p
      v-if="isOnboardingRedesign"
      class="tw-mt-8"
    >
      List your medical condition(s)...
    </p>

    <Array
      v-if="activateOthers || isOnboardingRedesign"
      ref="array"
      :body="arrayBody"
      :others-field="others"
      @submitAnswer="checkAnswer"
      @alert="alert"
    />

    <OnboardingCTAContainer>
      <b-button
        v-if="!activateOthers"
        variant="info"
        block
        pill
        :disabled="isOnboardingRedesign ? (disabled || disableButton) : disabled"
        class="slight-rounded"
        :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
        @click="checkAnswer"
      >
        Continue
      </b-button>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import Array from '@/components/onboarding/questions/Array';
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';

export default {
  components: {
    Array,
    OnboardingCTAContainer
  },
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      answers: [],
      others: [],
      activateOthers: false,
      arrayBody: {},
      none: false,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    disableButton() {
      if (this.isOnboardingRedesign) {
        return this.answers.length == 0 && this.$refs.array?.answer.length == 0 && !this.none;
      }
      return !this.none && this.answers.length == 0 && this.others.length == 0;
    },
  },
  watch: {
    none() {
      if (this.none) {
        this.answers = [];
        this.activateOthers = false;
      }
    },
    answers() {
      if (this.answers.length > 0) {
        this.none = false;
      }
    },
    activateOthers() {
      if (this.activateOthers) {
        this.none = false;
      }
    },
  },
  async mounted() {
    if (this.body.hasOwnProperty('answer')) {
      this.answers = this.body.answer;
      if (this.body.answer.length == 0 && !this.body.hasOwnProperty('others')) {
        this.none = true;
        return;
      }
      if (this.body.hasOwnProperty('others')) {
        this.activateOthers = true;
        this.others = this.body.others;
        this.arrayBody = { answer: this.body.others }
      }
    }
  },
  methods: {
    alert(msg) {
      this.$emit('alert', msg);
    },
    checkAnswer(_id = null, others = null, _body = null) {
      if (this.isOnboardingRedesign) {
        this.others = this.$refs.array.answer;
      } else {
        if (this.activateOthers) {
          this.others = others;
        }
      }

      if (this.body.allowempty) {
        // * If "none" is not selected, and no other answers and others have not been supplied
        if (!this.none && this.answers.length == 0 && this.others.length == 0) {
          this.$emit('alert', 'Please select an option.');
          return;
        }
      }

      this.$emit(
        'submitAnswer',
        this.body.id,
        this.answers,
        this.body,
        null,
        this.others
      );
    },
  },
};
</script>
